import Image from "@components/Image";
import cx from "classnames";
import styles from "./Paragraph2.module.scss";
import _ from "lodash";

const View = ({ content, image }: any) => {
  return (
    <div className={cx(styles.section)}>
      <Image
        wrapperProps={{ className: cx(styles.image) }}
        src={_.get(image, "src", "") ?? "/brand-story/3.jpg"}
        alt={_.get(image, "alt", "") ?? "brand-story-image-3"}
        layout="fill"
        objectFit="cover"
      />
      <div className={cx(styles.textContent)}>{content}</div>
    </div>
  );
};

export default View;
